import InputContainer from "../../../common/InputContainer";
import "./Browse.css";
import DisplaySearch from "./DisplaySearch";
import { useTranslation } from "react-i18next";

const BrowseTemplates = ({
    searchButtonIsGray,
    templates,
    isLoading,
    setMetaData,
    onSearchInput,
    selectedTemplates,
    searchItem,
}) => {
    const { t } = useTranslation("templatesPage");

    const handelKeyPress = (event) => {
        if (event.key === "Enter") {
            searchItem();
        }
    };

    return (
        <InputContainer
            placeholder={t("browesPagePlaceholderSearch")}
            buttonText={t("browsePageButtonSearch")}
            buttonOnClick={() => searchItem()}
            onInput={onSearchInput}
            buttonIsGray={searchButtonIsGray}
            content={
                <DisplaySearch
                    templates={templates}
                    setMetaData={setMetaData}
                    isLoading={isLoading}
                    selectedTemplates={selectedTemplates}
                />
            }
            onKeyPress={(e) => handelKeyPress(e)}
        />
    );
};

export default BrowseTemplates;
